<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div class="layout-style-grid">
	<div
		*ngFor="let lookup of layoutStyleLookupData"
		class="flex-layout-column layout-style-option"
		[ngClass]="{ 'layout-picker-selected-background': writtenValue === lookup.id }"
		(click)="onLayoutStyleSelected(lookup.id)"
		(keydown.enter)="onLayoutStyleSelected(lookup.id)"
		[matTooltip]="getTooltip(lookup.id)"
		[tabIndex]="startTabIndex + lookup.id"
	>
		<div class="icon-row">
			<ng-container *ngFor="let icon of getIcons(lookup.id)">
				<span class="material-symbols-outlined layout-style-img">{{ icon }}</span>
			</ng-container>
		</div>
		<span class="icon-label">{{ getLabel(lookup.id) }}</span>
	</div>
</div>
